import { render, staticRenderFns } from "./ExamSession.vue?vue&type=template&id=35ac65b3"
import script from "./ExamSession.vue?vue&type=script&lang=js"
export * from "./ExamSession.vue?vue&type=script&lang=js"
import style0 from "./ExamSession.vue?vue&type=style&index=0&id=35ac65b3&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ac65b3')) {
      api.createRecord('35ac65b3', component.options)
    } else {
      api.reload('35ac65b3', component.options)
    }
    module.hot.accept("./ExamSession.vue?vue&type=template&id=35ac65b3", function () {
      api.rerender('35ac65b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/exam/ExamSession.vue"
export default component.exports